import * as logopng from "./logo.png";
import * as React from "react";

export function Logo()
{
    return <img src={logopng} alt="GameScorekeeper" width="350" />;
}
